module.exports = __webpack_public_path__ + "static/media/Cost-illustration.5b95c81b.svg";